/**
 * 信令连接展示数据格式化工具。
 */
const DEFAULT_EXPIRATION_TEXT =
	"This invitation will expire soon. Please start the session promptly.";

type DeviceInfo = {
	platform?: string;
	os?: string;
	hostname?: string;
};

type SessionInfo = {
	location?: string;
	ipv4?: string;
	ip?: string;
	ip_address?: string;
};

type ConnectionSummary = {
	expiresAt?: string;
	deviceInfo?: DeviceInfo | null;
	sessionInfo?: SessionInfo | null;
};

/**
 * 根据过期时间输出用户可读的提示文本。
 * @param {string | undefined} expiresAt 过期时间
 */
export const buildExpirationText = (expiresAt?: string) => {
	if (!expiresAt) return DEFAULT_EXPIRATION_TEXT;

	try {
		const expires = new Date(expiresAt);
		if (Number.isNaN(expires.getTime())) {
			return DEFAULT_EXPIRATION_TEXT;
		}
		return `Invitation expires at ${expires.toLocaleString()}`;
	} catch (error) {
		console.error("format expiresAt failed:", error);
		return DEFAULT_EXPIRATION_TEXT;
	}
};

const resolveOperatingSystem = (deviceInfo?: DeviceInfo | null) => {
	if (!deviceInfo) return "Unknown Platform";
	return deviceInfo.platform || deviceInfo.os || "Unknown Platform";
};

const resolveIpAddress = (sessionInfo?: SessionInfo | null) => {
	if (!sessionInfo) return "--";
	return sessionInfo.ipv4 || sessionInfo.ip || sessionInfo.ip_address || "--";
};

/**
 * 从原始连接摘要中提取页面展示所需字段。
 * @param {ConnectionSummary | null | undefined} connectionSummary 连接摘要
 */
export const buildInvitationPresentation = (
	connectionSummary?: ConnectionSummary | null,
) => {
	const sessionInfo = connectionSummary?.sessionInfo || null;
	const deviceInfo = connectionSummary?.deviceInfo || null;

	return {
		formattedExpirationText: buildExpirationText(connectionSummary?.expiresAt),
		deviceLocation: sessionInfo?.location ?? "--",
		inviteeName: deviceInfo?.hostname ?? "Remote Device",
		operatingSystem: resolveOperatingSystem(deviceInfo),
		ipAddress: resolveIpAddress(sessionInfo),
	};
};
